// Mount the mall app into #app. The custom element is defined on import;
// appending it here (instead of relying on a tag in index.html) keeps the
// index template minimal and makes the mount point explicit.
import './app-root.js';
import { APP_DISPLAY_NAME } from './lib/demo.js';

// Environment label: "PharmaPOS Mall (DEMO)" on mall.demo.pharmapos.com.
document.title = APP_DISPLAY_NAME;

const container = document.getElementById('app');
if (container && !container.querySelector('app-root')) {
  container.appendChild(document.createElement('app-root'));
}
